import PageContainer from '@/components/PageContainer.js';

import { clinicCrud } from '@/services/firebase';
import { EntityList } from '@/components/EntityManagement';
import { useFirequery } from '@ajorquera/libs/react';
import { useNavigate } from 'react-router-dom';
import { Clinic } from '@/types/database.js';
import { FC, useMemo } from 'react';
import { deleteClinic } from '@/services/api';
import { Dict } from '@ajorquera/libs/utils';

const ClinicManagementPage: FC = () => {
  const { data: clinicsData, loading: loadingClinics } = useFirequery<Clinic[]>(clinicCrud.query());
  const navigate = useNavigate();

  const clinics = useMemo(
    () =>
      clinicsData?.map((clinic: Clinic) => ({
        id: clinic.id as string,
        primary: clinic.name as string,
        secondary: clinic.email as string,
        icon: 'healthicons:ambulatory-clinic-outline',
        to: `${clinic.id}`,
      })),
    [clinicsData]
  );

  const onClick = (item: Dict, action: string) => {
    if (action === 'Delete' && item.id) {
      deleteClinic(item?.id);
    } else if (action === 'Edit' && item?.id) {
      navigate(item.id);
    }
  };

  return (
    <PageContainer title="manageClinicsTitle" description="manageClinicsDescription">
      <EntityList mt={5} actions={['Delete']} onClick={onClick} items={clinics} loading={loadingClinics} />
    </PageContainer>
  );
};

export default ClinicManagementPage;
